export const ICON_SIZE = 24;
